import * as actionTypes from './actionTypes';
import API from '../../axios/api';
import axios from 'axios';
let CancelToken = axios.CancelToken;
let getServiceFormActions_cancel;


export const clearServiceForm = () => {
    return {
      type: actionTypes.SERVICE_FORM_CLEAR_FORM,
    };
  }

export const setPlaceServiceForm = (place, site) => {
    return {
        type: actionTypes.SERVICE_FORM_SET_PLACE,
        place: place,
        site: site
    };
}
// novo reducer p/ quando já tiver equipamento selecionado
export const setPlaceServiceFormWithEquipment = (place, site) => {
  return {
      type: actionTypes.SERVICE_FORM_SET_PLACE_EQUIPMENT,
      place: place,
      site: site
  };
}

export const setEquipmentServiceForm = (equipment) => {
    return {
        type: actionTypes.SERVICE_FORM_SET_EQUIPMENT,
        equipment: equipment
    };
}

export const setEquipmentServiceServiceForm = (equipmentService) => {
    return {
        type: actionTypes.SERVICE_FORM_SET_EQUIPMENT_SERVICE,
        equipmentService: equipmentService
    };
}

export const populateQuestionsServiceForm = (questions, shouldAnswerWithNA) => {
    return {
      type: actionTypes.SERVICE_FORM_START_POPULATE_QUESTIONS,
      questions,
      shouldAnswerWithNA,
    };
  }

export const populateEditQuestionsServiceForm = (questions) => {
    return {
      type: actionTypes.SERVICE_FORM_START_POPULATE_EDIT_QUESTIONS,
      questions: questions
    };
  }

export const answerQuestionServiceForm = (answer, question) => {
  return {
    type: actionTypes.SERVICE_FORM_ANSWER_QUESTION,
    answer: answer,
    question: question
  };
};

export const answerAllQuestionWithNA = () => {
  return {
    type: actionTypes.SERVICE_FORM_ANSWER_ALL_WITH_NA,
  }
}

export const commentQuestionServiceForm = (comment, question) => {
  return {
    type: actionTypes.SERVICE_FORM_COMMENT_QUESTION,
    comment: comment,
    question: question
  };
};

export const addFileQuestionServiceForm = (files, questionId) => {
  return {
    type: actionTypes.SERVICE_FORM_ADD_FILE_QUESTION,
    files,
    questionId,
  };
}

export const editFileQuestionServiceForm = (fileId, file, questionId) => {
  return {
    type: actionTypes.SERVICE_FORM_EDIT_FILE_QUESTION,
    fileId,
    file,
    questionId,
  };
}

export const deleteFileQuestionServiceForm = (fileId, questionId) => {
  return {
    type: actionTypes.SERVICE_FORM_DELETE_FILE_QUESTION,
    fileId,
    questionId,
  };
}

export const addActionToQuestionServiceForm = (action) => {
  return {
    type: actionTypes.SERVICE_FORM_ADD_ACTION,
    action: action
  };
};

export const editActionToQuestionServiceForm = (actionId, action) => {
    return {
      type: actionTypes.SERVICE_FORM_EDIT_ACTION,
      actionId,
      action: action
    };
  };

export const deleteActionFromQuestionServiceForm = (actionId) => {
  return {
    type: actionTypes.SERVICE_FORM_DELETE_ACTION,
    actionId: actionId
  }
}

export const setDateServiceForm = (date) => {
    return {
      type: actionTypes.SERVICE_FORM_SET_DATE,
      date: date
    };
  };
  
  export const setDescriptionServiceForm = (description) => {
    return {
      type: actionTypes.SERVICE_FORM_DESCRIPTION,
      description: description
    }
  }

export const changeSiteServiceForm = () => {
    return {
        type: actionTypes.SERVICE_FORM_CHANGE_SITE,
    }
}

export const deleteActionToQuestionService = (action) => {
  return {
    type: actionTypes.DELETE_ACTION,
    action: action,
  }
}


const getOldActionsStart = () => {
  return {
    type: actionTypes.SERVICE_FORM_GET_OLD_ACTIONS_START,
  }
}

const getOldActionsSucess = (actions) => {
  return {
    type: actionTypes.SERVICE_FORM_GET_OLD_ACTIONS_SUCCESS,
    actions,
  }
}

const getOldActionsFail = () => {
  return {
    type: actionTypes.SERVICE_FORM_GET_OLD_ACTIONS_FAIL,
  }
}

export const getOldActions = (equipmentId, equipmentServiceId, serviceDate = '') => {
  getServiceFormActions_cancel && getServiceFormActions_cancel()

  return dispatch => {
    dispatch(getOldActionsStart());
    const beforeQuery = serviceDate !== '' ? `?before=${serviceDate}` : '';
    API.get(`/actions/oldactionsfornewservice/${equipmentId}/${equipmentServiceId}${beforeQuery}`, {
      cancelToken: new CancelToken(function executor(c) {
        getServiceFormActions_cancel = c;
      })
    })
      .then(res => {
        dispatch(getOldActionsSucess(res.data));
      })
      .catch(err => {
        console.log(err)
        dispatch(getOldActionsFail());
      });
  };
}
